<template>
  <div id="back-nav" class="tw-w-full tw-mt-0 md:tw-mb-4 tw-flex tw-justify-start tw-items-center" @click="navTo">
    <div class="tw-flex tw-w-20 tw-cursor-pointer tw-items-center">
      <v-icon class="c-bg-blue tw-rounded-full tw-w-6 tw-h-6" color="#fff">mdi-arrow-left</v-icon>
      <span class="c-gray-text tw-ml-2">Previous</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BackNav',
  props: {
    to: String,
  },
  methods: {
    navTo() {
      if (this.to === null) this.$router.go(-1);
      this.$root.$emit('nav-back-to', { currentTab: this.to });
    },
  },
};
</script>
